module.exports = __webpack_public_path__ + "media/images/sp/stores/asakusa/asakusa_sns_01-990d91b4d39319f41c37e24962108556.jpg";